module.exports = __webpack_public_path__ + "img/libra.e5769d27.png";